<template>
  <div>
    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="../../../assets/img/logossg.png" />
        </div>
        <!-- <div class="line"></div>
        <div class="back" @click="back">返回项目列表</div> -->
         <div>
          <el-dropdown @command="addCommand">
            <div class="icon">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>

            <el-dropdown-menu slot="dropdown">
              <div>
                <el-dropdown-item command="a"> 返回首页 </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="company">{{ this.$route.query.projectName }}</div>
    </div>
    <el-container>
      <el-main>
        <!-- <div class="box">
          <p class="return" @click="$router.go(-1)">返回</p>
          <span class="line">|</span>
          <p class="contract">项目列表</p>
          <span class="lines">></span>
          <p class="contract">关联设置</p>
        </div> -->
        <div class="area" style="padding:0px 30px">
          <div class="leftNav">
            <el-row class="tac">
              <el-col :span="20">
                <el-menu
                  :router="true"
                  :unique-opened="false"
                  :default-openeds="['1', '2']"
                  background-color="#f7f8fc"
                  :default-active="selectUrl"
                  class="el-menu-vertical-demo"
                  @open="handleOpen"
                  @close="handleClose"
                >
                 <el-menu-item-group>
                    <div class="linesss">
                      <el-menu-item :index="`/ssgSplat/settings/employPlatform?code=${this.code}&id=${this.id}`"
                        >企业多元用工平台</el-menu-item
                      >
                      <el-badge
                        v-if="num > 0"
                        style="margin: 7px 10px 0 0"
                        :value="num"
                      >
                      </el-badge>
                    </div>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <div class="linesss">
                      <el-menu-item :index="`/ssgSplat/settings/relateRpoSetting?code=${this.code}&id=${this.id}`"
                        >嗖嗖RPO</el-menu-item
                      >
                      <el-badge
                        v-if="num > 0"
                        style="margin: 7px 10px 0 0"
                        :value="num"
                      >
                      </el-badge>
                    </div>
                  </el-menu-item-group>

                  <el-menu-item-group>
                    <div data-permissions="view:ssg:showsspproject" v-has class="linesss">
                      <el-menu-item
                        :index="`/ssgSplat/settings/relatedSetting?code=${this.code}`"
                        >嗖嗖发薪</el-menu-item
                      >
                      <el-badge
                        v-if="dort > 0"
                        style="margin: 7px 10px 0 0"
                        :value="dort"
                      >
                      </el-badge>
                    </div>
                  </el-menu-item-group>
                </el-menu>
              </el-col>
            </el-row>
          </div>
          <div class="rightNav">
            <router-view></router-view>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      code: "",
      id:'',
      selectUrl: "",
      dort: "",
      num:'',
      total: 10,
      pageNo: 1,
      pageSize: 10,
      form: {
        status: "",
        itemName: "",
        itemId: "1",
        company: "",
      },
    };
  },
  created() {
    this.loadData()
    this.load()
    var _this = this;
    _this.$root.$on("callbackdot", function (val) {
      _this.dort = val;
    });
    _this.$root.$on("callbacknum", function (val) {
      _this.num = val;
    });
    // if (
    //   this.$route.fullPath.indexOf("/main/system/system/contractCompany") >
    //     -1 ||
    //   this.$route.fullPath.indexOf("/main/system/system/contractCompany/seal") >
    //     -1 ||
    //   this.$route.fullPath.indexOf("/main/system/system/contractCompany/seal/create") >
    //     -1

    // ) {
    //   this.selectUrl = "/main/system/system/contractCompany";
    // } else {
    this.selectUrl = this.$route.fullPath;
    this.code = this.$route.query.code;
    this.id = this.$route.query.id;

    // }
  },
  methods: {
     addCommand(command) {
      if (command == "a") {
        this.$router.push({ path: "/main" });
      }
    },
     loadData() {
      const params = {
        ssgProjectId: this.$route.query.id,
        // ssgProjectId: 323,
        
      };
      return this.$axios
        .get("/rpoProjectRelvance/queryRpoProjectList", {
          params,
        })
        .then((res) => {
          this.num = res.data.data.newRequestNum;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
      
    },
    load(){
     const param = {
        code: this.$route.query.code,
      };
      return this.$axios
        .get("/project/findSSPProjectList?code="+this.$route.query.code)
        .then((res) => {
          this.dort = res.data.data.newRequestNum;
          console.log(this.dort)

        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    search() {},
    // 重置搜索条件
    reset() {},
    ontypeof() {},
    // 加载指定页面的数据信息
    cur(val) {
      this.pageNo = val;
      // this.loadData();
    },
    back() {
      this.$router.push({ path: "/ssgSplat" });
    },
  },
};
</script>
<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../../assets/css/common/card.less" scoped lang="less"></style>
<style  scoped>
/* html {
    height: 100%;
    overflow:scroll;
    overflow-y: hidden;
} */
</style>
<style scoped lang="less">

.box {
  display: flex;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  .icon {
    margin: 10px auto;
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d8dae1;
    margin-left: 20px;
    i {
      margin: 3px;
    }
  }
  .left {
    display: flex;
    align-items: center;
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 64, 1);
    margin-right: 30px;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    cursor: pointer;
  }
  .logo {
    margin-left: 30px;
  }
}
.el-container {
  height: calc(100vh - 60px);
}

.area {
  display: flex;
  // margin-top: 80px;
  // height:100%;

  .leftNav {
    width: 20%;
    // position:sticky;
    // top:0px;
    // z-index: 999;
    // background:#fff;
  }

  .rightNav {
    width: 80%;

    .box {
      display: flex;

      .return {
        font-size: 14px;
        color: #409eff;
        margin-right: 20px;
        cursor: pointer;
      }

      .line {
        margin-right: 20px;
        color: #606266;
      }

      .lines {
        margin-right: 20px;
        color: #606266;
        font-weight: bold;
      }

      .contract {
        margin-right: 20px;

        font-size: 14px;
        font-weight: bold;
        color: #606266;
      }
    }
  }
}

.tab_nav[data-v-4d83a540] {
  border-bottom: 0;
}

.filterdiv {
  width: 100%;
  /*margin: 32px 0;*/
  /*padding: 24px 16px 20px;*/
  background-color: #f2f5f8;
  box-sizing: border-box;
  border: 1px solid #d9dbe2;
  border-radius: 6px;

  form {
    display: flex;
    align-items: center;
  }
}

.btn {
  min-width: 110px;
  background-color: transparent;
}

.subbtn {
  background-color: #409eff;
  color: #fff;
}

.row {
  width: 100%;
  display: flex;
  // align-items: center;
  padding-bottom: 16px;

  .label {
    width: 55px;
    min-width: 55px;
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
    margin-top: 6px;
  }
}

.inputdiv {
  width: 100%;
  height: 66px;
  border-top: 1px solid #d9dbe2;
  display: flex;

  .inputs {
    width: 100%;
    display: flex;
    align-items: center;

    .idiv {
      width: 100%;
      display: flex;
      align-items: center;

      .label {
        width: 160px;
        font-size: 12px;
        /*text-align: center;*/
      }

      .input {
        width: 100%;
        height: 34px;
        background-color: #fff;
        border: 1px solid #d9dbe2;
        border-radius: 6px;
        padding-right: 24px;
        padding-left: 10px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;

        i {
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -6px;
        }
      }
    }
  }

  .btns {
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;

    button {
      min-width: 84px;
    }
  }
}

.input > .in_boxs {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.in_boxs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .in_box {
    width: auto;
    display: flex;
    align-items: center;
    height: 22px;
    background-color: #409eff;
    color: #fff;
    padding: 0 7px;
    border-radius: 4px;
    margin-right: 10px;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .text {
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    margin-right: 8px;
  }

  span {
    cursor: pointer;
    font-size: 18px;
  }
}

.centerNav {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .centerBtn {
    margin-top: 10px;

    button {
      margin-left: 10px;
    }
  }
}

.nav {
  font-weight: bold;
  color: #303140;
}

.el-menu-item.is-active {
  border-left: 4px solid #6669e3;
  color: #6669e3;
  // margin-left: -2px;
  background-color: #eceef4 !important;
  width: 100%;
  padding-left: 24px !important;
}

.demo-block.demo-menu .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 152px;
  min-height: 400px;
}

.el-submenu .el-menu-item {
  min-width: 0;
  width: 100%

}

.el-form--inline .el-form-item {
  margin: 8px 0 8px 8px;
}

.el-form-item {
  margin: 0;
}
.el-menu-item {
  font-size: 14px;
  padding: 0 28px !important;
  cursor: pointer;
  height: 40px;
  color: #303140;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}
.el-menu-item:hover {
  outline: 0 !important;
  background-color: #eceef4 !important;
  width: 100%;

}
.el-menu {
  border-right: 0;
}
.area[data-v-2cb4e93a] {
  width: 100%;
  max-width: 1920px;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
}
.linesss {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.leftNav /deep/ .el-menu-item-group__title {
      padding: 0px 0 0 20px;
}
.leftNav /deep/ .el-menu-item-group__title .is-active{
      padding: 0px 0 0 16px;
}
.leftNav /deep/ .el-menu {
    padding: 15px 0;
}
</style>